export default "__VITE_ASSET__CTuTRAQB__"